import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse, AccountUser, AddUserDto } from '@/types';

export const accountUsersService = {
  async list(accountId: number): Promise<AccountUser[]> {
    const res = await api.get<ApiResponse<{ users: AccountUser[] }>>(
      API_ENDPOINTS.ACCOUNT_USERS.BASE(accountId)
    );
    return res.data.data.users;
  },

  async add(accountId: number, payload: AddUserDto) {
    const res = await api.post<ApiResponse<Record<string, unknown>>>(
      API_ENDPOINTS.ACCOUNT_USERS.BASE(accountId),
      payload
    );
    return res.data.data;
  },

  async setRole(accountId: number, userId: number, role: number) {
    const res = await api.patch<ApiResponse<Record<string, unknown>>>(
      API_ENDPOINTS.ACCOUNT_USERS.BY_ID(accountId, userId),
      { role }
    );
    return res.data.data;
  },

  async remove(accountId: number, userId: number) {
    const res = await api.delete<ApiResponse<Record<string, unknown>>>(
      API_ENDPOINTS.ACCOUNT_USERS.BY_ID(accountId, userId)
    );
    return res.data.data;
  }
};
